import React, { useEffect, useContext, useCallback } from "react";
import BaseApi from "../../../../functions/axios";
import { useNavigate } from "react-router-dom";
import { DataGrid, jaJP } from "@mui/x-data-grid";
import { Paper, useMediaQuery } from "@mui/material";
import { recruitmentListContext } from "../../RecruitmentListPage";
import OverflowX from "../../../../components/OverflowX";

const columns = [
  { field: "id", headerName: "ID", headerAlign: "center", sortable: false, width: 80 },
  { field: "mail_subject", headerName: "件名", headerAlign: "center", sortable: false, width: 500 },
  { field: "cost_high", headerName: "単価(万円)", type: "number", headerAlign: "center", width: 100 },
  { field: "actual_work", headerName: "稼働時期", headerAlign: "center", sortable: false, width: 320 },
  {
    field: "mail_subject_smallScreen",
    headerName: "件名",
    headerAlign: "center",
    sortable: false,
    width: 550,
    valueGetter: (params) => params.row?.mail_subject,
  },
  {
    field: "cost_high_smallScreen",
    headerName: "単価(万円)",
    type: "number",
    headerAlign: "center",
    width: 100,
    valueGetter: (params) => params.row?.cost_high,
  },
  {
    field: "actual_work_smallScreen",
    headerName: "稼働時期",
    headerAlign: "center",
    sortable: false,
    width: 370,
    valueGetter: (params) => params.row?.actual_work,
  },
];

export default function RecruitmentList() {
  const {
    searchCondition,
    setSearchCondition,
    isEndList,
    setIsEndList,
    isBottom,
    recruitmentList = [],
    setRecruitmentList,
    setIsBottom,
  } = useContext(recruitmentListContext);

  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery("(max-width: 600px)");

  const visibleColumns = isSmallScreen
    ? ["mail_subject_smallScreen", "cost_high_smallScreen", "actual_work_smallScreen"]
    : ["id", "mail_subject", "cost_high", "actual_work"];

  const fetchNextPage = useCallback(async () => {
    try {
      const response = await BaseApi.get("project_list", { params: searchCondition });
      const data = response?.data?.data || {};
      const newList = data.project_list || [];

      setRecruitmentList((prev) => [...prev, ...newList]);

      if (data.next === 0) {
        setIsEndList(true);
      } else {
        setSearchCondition((prev) => ({
          ...prev,
          offset: data.next,
        }));
      }
    } catch (err) {
      console.error("fetchNextPage error:", err);
    }
  }, [searchCondition, setRecruitmentList, setIsEndList, setSearchCondition]);

  useEffect(() => {
    if (isBottom && !isEndList && recruitmentList.length > 0) {
      fetchNextPage();
    }
  }, [isBottom, isEndList, recruitmentList.length, fetchNextPage]);

  const handleRowClick = (params) => {
    navigate("/recruitmentDetail", {
      state: { projectId: params.id },
    });
  };

  return (
    <OverflowX minWidth={1000} setIsBottom={setIsBottom}>
      <Paper sx={{ flexGrow: 1 }}>
        <DataGrid
          rows={recruitmentList}
          columns={columns.filter((column) => visibleColumns.includes(column.field))}
          onRowClick={handleRowClick}
          hideFooter
          disableColumnSelector
          disableColumnFilter
          disableColumnMenu
          disableSelectionOnClick
          autoHeight
          localeText={jaJP.components.MuiDataGrid.defaultProps.localeText}
          sx={{
            ".MuiDataGrid-columnHeaderTitle": { fontWeight: "bold" },
            "& .MuiDataGrid-row:hover": {
              boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.3)",
              zIndex: 1,
            },
            "& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus": {
              outline: "none",
            },
            fontSize: "14px",
          }}
        />
      </Paper>
    </OverflowX>
  );
}